<article
  class="rounded-[2rem] bg-white px-4 py-4 shadow-sm transition-all"
  [class.border]="draft().selected"
  [class.border-orange-300]="draft().selected"
  [class.bg-[#fffaf6]]="draft().selected"
  [class.border-transparent]="!draft().selected"
>
  <div class="flex items-start gap-3">
    <button
      type="button"
      (click)="toggleSelected.emit()"
      class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 transition-all"
      [class.border-orange-500]="draft().selected"
      [class.bg-orange-500]="draft().selected"
      [class.text-white]="draft().selected"
      [class.border-black/10]="!draft().selected"
    >
      @if (draft().selected) {
        ✓
      }
    </button>

    <div class="min-w-0 flex-1">
      <h3 class="text-lg font-semibold uppercase tracking-tight text-[#1f1b16]">
        {{ item().description }}
      </h3>

      <p class="text-sm font-medium text-[#3a332c]/65">
        {{ item().quantity }}x ${{ item().unitPrice | number: '1.0-2' }}
      </p>
    </div>
  </div>

  @if (draft().selected && draft().expanded) {
    <div class="mt-4 border-t border-black/[0.05] pt-4 space-y-4">
      <div class="grid grid-cols-2 gap-2">
        <button
          type="button"
          (click)="modeChange.emit('EQUAL_SHARE')"
          class="rounded-xl py-2.5 text-sm font-semibold transition"
          [class.bg-orange-500]="draft().mode === 'EQUAL_SHARE'"
          [class.text-white]="draft().mode === 'EQUAL_SHARE'"
          [class.bg-[#f6f1eb]]="draft().mode !== 'EQUAL_SHARE'"
          [class.text-[#3a332c]/60]="draft().mode !== 'EQUAL_SHARE'"
        >
          Partes iguales
        </button>

        <button
          type="button"
          (click)="modeChange.emit('BY_QUANTITY')"
          class="rounded-xl py-2.5 text-sm font-semibold transition"
          [class.bg-orange-500]="draft().mode === 'BY_QUANTITY'"
          [class.text-white]="draft().mode === 'BY_QUANTITY'"
          [class.bg-[#f6f1eb]]="draft().mode !== 'BY_QUANTITY'"
          [class.text-[#3a332c]/60]="draft().mode !== 'BY_QUANTITY'"
        >
          Por cantidad
        </button>
      </div>

      @if (draft().mode === 'EQUAL_SHARE') {
        <div class="space-y-3">
          @if (item().quantity > 1) {
            <button
              type="button"
              (click)="equalShareScopeChange.emit('FULL_ITEM')"
              class="w-full rounded-xl px-4 py-3 text-left text-sm font-semibold transition border"
              [class.border-orange-300]="draft().equalShareScope === 'FULL_ITEM'"
              [class.bg-orange-50]="draft().equalShareScope === 'FULL_ITEM'"
              [class.border-transparent]="draft().equalShareScope !== 'FULL_ITEM'"
              [class.bg-[#f6f1eb]]="draft().equalShareScope !== 'FULL_ITEM'"
            >
              Todo el item ({{ item().quantity }})
            </button>
          }

          @if (item().quantity > 1) {
            <div
              class="rounded-xl px-4 py-3 transition border"
              [class.border-orange-300]="draft().equalShareScope === 'PARTIAL_QUANTITY'"
              [class.bg-orange-50]="draft().equalShareScope === 'PARTIAL_QUANTITY'"
              [class.border-transparent]="draft().equalShareScope !== 'PARTIAL_QUANTITY'"
              [class.bg-[#f6f1eb]]="draft().equalShareScope !== 'PARTIAL_QUANTITY'"
            >
              <button
                type="button"
                (click)="equalShareScopeChange.emit('PARTIAL_QUANTITY')"
                class="w-full text-left text-sm font-semibold"
              >
                Solo una parte
              </button>

              @if (draft().equalShareScope === 'PARTIAL_QUANTITY') {
                <div class="mt-4 space-y-3">
                  <div class="flex items-center justify-center gap-4">
                    <button
                      type="button"
                      (click)="decrementEqualShareQuantity()"
                      class="h-10 w-10 rounded-full bg-white text-xl font-semibold shadow-sm"
                    >
                      −
                    </button>

                    <div class="text-center">
                      <p class="text-2xl font-bold">{{ draft().equalShareQuantity ?? 1 }}</p>
                    </div>

                    <button
                      type="button"
                      (click)="incrementEqualShareQuantity()"
                      class="h-10 w-10 rounded-full bg-white text-xl font-semibold shadow-sm"
                    >
                      +
                    </button>

                    <span class="text-sm text-[#3a332c]/60"> de {{ item().quantity }} </span>
                  </div>

                  <p class="text-xs text-[#3a332c]/60">
                    Se dividirá en partes iguales con quienes seleccionen lo mismo.
                  </p>
                </div>
              }
            </div>
          }

          @if (item().quantity === 1) {
            <p class="rounded-xl bg-[#f6f1eb] px-4 py-3 text-sm text-[#3a332c]/70">
              Este ítem se tomará completo y se dividirá en partes iguales con quienes seleccionen
              lo mismo.
            </p>
          }
        </div>
      }

      @if (draft().mode === 'BY_QUANTITY') {
        <div class="space-y-3">
          <p class="text-sm text-center text-[#3a332c]/70">Cantidad que consumiste</p>

          <div class="flex items-center justify-center gap-4">
            <button
              type="button"
              (click)="decrementQuantity()"
              class="h-10 w-10 rounded-full bg-[#f6f1eb] text-xl font-semibold"
            >
              −
            </button>

            <div class="text-center">
              <p class="text-2xl font-bold">{{ draft().quantity ?? 1 }}</p>
            </div>

            <button
              type="button"
              (click)="incrementQuantity()"
              class="h-10 w-10 rounded-full bg-[#f6f1eb] text-xl font-semibold"
            >
              +
            </button>

            <span class="text-sm text-[#3a332c]/60"> de {{ item().quantity }} </span>
          </div>
        </div>
      }
      @if (draft().mode === 'UNRESOLVED' && !draft().suggestedGroups.length) {
        <div class="rounded-xl bg-[#f6f1eb] px-4 py-3">
          <p class="text-sm font-medium text-[#1f1b16]">El anfitrión lo resolverá</p>
          <p class="mt-1 text-xs text-[#3a332c]/60">
            Marcaste este consumo para que el anfitrión decida cómo dividirlo.
          </p>
        </div>
      }
      @if (draft().mode === 'UNRESOLVED' && draft().suggestedGroups.length) {
        <div class="rounded-xl bg-[#f6f1eb] px-4 py-3">
          <p class="text-sm font-medium text-[#1f1b16]">Sugerencia de separación de unidades</p>
          <p class="mt-1 text-xs text-[#3a332c]/60">
            Sugeriste {{ draft().suggestedGroups.length }}
            {{ draft().suggestedGroups.length === 1 ? 'grupo' : 'grupos' }}
            para ayudar al anfitrión a resolverlo.
          </p>
        </div>
      }
      @if (item().quantity > 1) {
        <div class="text-center pt-1">
          <button
            type="button"
            (click)="unresolvedClick.emit()"
            class="text-sm font-medium text-[#3a332c]/60 underline underline-offset-4"
          >
            No puedo representarlo bien
          </button>
        </div>
      }
    </div>
  }
</article>
